// extracted by mini-css-extract-plugin
export const articleList = "highlights-module--articleList--2gjrM";
export const articleContent = "highlights-module--articleContent--29H6Y";
export const previewTitle = "highlights-module--previewTitle--3RTs5";
export const publishDate = "highlights-module--publishDate--U_gpd";
export const articleDescription = "highlights-module--articleDescription--1eeIV";
export const readMore = "highlights-module--readMore--28KUv";